define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dijit/form/Button",
	"./_Plugin",
	"./util"
], function(array,declare,Button,_Plugin, util) {

	return declare([Button, _Plugin], {
		bBack: false,

		enablePlugin: function(/*Shape[]*/shapes, /*Object*/shapeAttrs, /*Object*/textAttrs) {
			// summary: only enable if selected shape(s)
			if(this.inherited(arguments)) {
				return !!shapes && this.editor.isDefaultCanvasMode() && util.unlockedShapedCount(shapes) === shapes.length;
			}

			return false;
		},

		onClick: function(/*Event*/e) {
			// summary: move selected shapes making sure to maintain same order as currently in DOM
			this.editor.changeSortOrder(this.bBack);
		}
	});
});
